import { render, staticRenderFns } from "./MoldKanbanTV.vue?vue&type=template&id=5e965f61&"
import script from "./MoldKanbanTV.vue?vue&type=script&lang=js&"
export * from "./MoldKanbanTV.vue?vue&type=script&lang=js&"
import style0 from "./MoldKanbanTV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports